// 根据电脑来判断语言
module.exports = {
	toast: {
		agreementTips: '規約に同意する必要があります',
		nopsw: 'パスワードを入力してください',
		verifypAccount: 'アカウントのフォーマットが正しくありません',
		noAccount: 'アカウントを入力してください账号不能为空',
		gotoGame: 'ログイン',
		noPhone: 'メールアドレスを入力してください',
		verifyphoneTips: '正しいメールアドレスを入力してください',
		verifycodeTips: '認証コードを入力してください',
		verifypswTips: 'パスワードは6~18桁の半角英数字です',
		newverifypswTips: '6~18桁の半角英数字を入力してください',

		noName: '名前を入力してください',
		noID: '身份证号不能为空',
		verifyIDTips: '请输入有效身份证号',
		confirmPswTips: '確認のため2回入力が必要です',

		accountPlaceholder: 'メールアドレスを入力してください',
		phonePlaceholder: 'メールアドレスを入力してください',
		pswPlaceholder: 'パスワードを入力してください',
		newPswPlaceHolder: '新しいパスワードを入力してください',
		confirmPswPlaceholder: 'パスワードを確認してください',
		IDPlaceholder: '请输入身份证号',
		namePlaceholder: '请输入真实姓名',
		verifycodePlaceholder: '認証コードをを入力してください',
		findAccountPlaceHolder: '復元したいアカウントをを入力してください',

		findAccountTxt1:
			'パスワードをリセットしたいアカウントを入力してください',
		findAccountTxt2:
			'送信を押すと、認証コードは次の方法で送信されます：連携中の',
		verifycodeBtn: '送信',
		verifycodeBtn2: '再送信',
		gotoRegister: '登録',
		findAccount: 'パスワードを忘れた場合',
		gotoAccountLogin: 'パスワードでログイン',
		agreementText: 'について確認、同意しました',
		userAgreementName: '利用規約',
		privacyAgreementName: 'プライバシーポリシー',
		agreementText2: '登録を行うと上記規約に同意したものとみなします',
		loginErrorTips:
			'アカウント活動に異常が検出されました。セキュリティ検証を完了してください',
		phoneVerify: 'メールアドレス認証',
		and: 'と',
		comfirmBtn1: '提出',
		comfirmBtn2: '確認',
		comfirmBtn3: '登録',
		comfirmBtn4: '戻る',
		comfirmBtn5: 'キャンセル',
		comunicaton1: 'メールアドレス',
		comunicaton2: 'メールアドレス',
		changepswTxt1: '新しいパスワ',
		changepswTxt2: 'ードを設定する',

		bannerGameTxt1: '注意',
		bannerGameTxt2:
			'您认证的身份信息为未成年人，请在监护人的监督下进行游戏。',
		bannerGameTxt3: '为了您的身心健康，请合理安排游戏时间',

		agreementTips1:
			'利用規約が更新されました。引き続きご利用いただくには、改訂後の利用規約に同意する必要があります。',
		agreementTips2:
			'引き続きプレイするには、規約について確認、同意する必要があります',
		agreementTips3: '拒否',
		agreementTips4: '同意',
		agreementTips5: '全ての内容を閲覧してから「同意」を押してください',
		agreementTips6: '規約について確認、同意してからログインしてください',

		bindIdTxt1: '根据国家要求规定，游戏用户必须进行实名认证，',
		bindIdTxt2: '我们承诺将严格保密您的信息安全。',

		bindPhoneTxt1: '連携するメールアドレスを入力してください：',

		loginErrorTxt1:
			'アカウント活動に異常が検出されました。セキュリティ検証を完了してください',
		loginErrorTxt2: 'メールアドレス認証：',

		successTitle: 'ようこそ「キャットファンタジー」へ',
	},
	myCard: {
        loginfirst: 'ゲームアカウントをログインしてください',
		gotogame: 'ログイン',
		gamename: 'チャージセンター『キャットファンタジ―』',
		titleAccount: 'アカウント情報',
		account: 'アカウント',
		activeAccount: '現在のアカウント',
		password: 'パスワード',
		titlePayWay: 'チャージ方法',
		titlePayAccount: 'チャージ金額',
		titlePayList: '宝石售价表',
		myCardPoint: 'MyCard点数',
		myCardGiftNum: '宝石（个）',
		submit: '提 出',
		change: 'チャージ',
		logout: 'ログアウト',
		gameRole: 'キャラクター',
		noGameRole:
			'キャラクターをバインドしていません。アカウントを切り替えてから再度お試しください',
		point: 'Pt',
		cardNum: 'カードID',
		cardPass: 'パスワード',
		placeholderCardNum: 'カードIDを入力',
		placeholderCardPass: 'パスワードを入力',
		extraGift: '特典',
		time: 'カウントダウン',
		timeout: '終了',
		payWay1: '钱包扣点',
		payWay2: '点数卡',
		payWay3: '会员扣点',
		payWay4: '卡片储值',
		secTitle1: 'イベント限定',
		secTitle2: 'お得',
		secTitle3: '専用割引',
		secTitle4: '通常ショップ',
		failed: '操作が失敗しました',
		tip: '※公式サイトによるチャージには、初回チャージ特典とチャージボーナスが付きません。',
		days: '日',
		pay1: 'お支払いを完了してください',
		pay2: '支払い完了',
		pay3: '結果が見つかりませんでした',
		pay4: 'お支払いがすでに完了した場合、後ほどゲーム内でご査収ください',
		pay5: '後ほどゲーム内でご査収ください',
		loginFirst: 'ゲームアカウントをログインしてください',
		extraSend: 'おまけ：',
		extraTitle: '購入数を入力',
		stock: '在庫：',
		otherNum: '購入数を入力',
		chooseCoupon: 'クーポンを選択',
		loginTips: 'ログインすると確認可能',
		noCoupon: '使えるクーポンがありません',
		expireAt: '失効日：',
		disCount: 'OFF',
		useType: '{amount}に達すると使用可能',
		proInfo: '商品情報：',
		proNum: '購入数：',
		roleInfo: 'キャラクター情報：',
		proPrice: '定価：',
		disCountPrice: '割引金額：',
		totalPrice: '合計：',
		inputNum: 'チャージ数を入力',
		maxNum: '割引上限額',
		closeMyCard: '閉じる',
		extraTips:
			'説明：入力する数値は6480〜99999以内の10の倍数である必要があります。',
		orderListTitle: '支払い履歴を確認',
		orderListSecTitle: '1年以内の履歴が確認できます',
		orderListEmpty: '購入履歴がありません',
		orderListPayWay: '支払い',
		orderListPayTime: '支払い時間:',
		orderListCreateTime: '注文時間:',
		orderListNum: '注文ID:',
		orderListExtra: 'VAT込み',
		orderListCloseTime: '注文締め切りまで:',
		orderListClose: '支払いを取り消す',
		orderListPay: '支払いへ進む',
		loadMore: 'もっと見る',
		orderTab1: '全て',
		orderTab2: '未払い',
		orderTab3: '支払済み',
		orderTab4: '取消済み',
		orderTab5: '期間切れ',
		navHome: 'ホーム',
		navMyOrder: '注文履歴',
		exchangeCoupon: 'クーポンを交換',
		exchangeTip: '交換コードを入力',
		exchangeCode: '交換コード:',
		exchangeCodeTip: '交換コードを入力(16桁の英字大文字と数字)',
		exchange: '交換',
		hasCoupon: 'クーポンを入手しました！',
		checkExchangeCoupon: 'クーポンを確認・交換',

		share: '可疊加',
		payTitle: '注文を確認する',
		payPrice: '注文金額',
		isFirst: '初のボーナス',
	},
	payRule: {
		title: '注意事項',
		text1: '1. 購入する際に、取引情報を細心にご確認ください。 ご購入頂いたアイテムは、他のアカウントに移動させることができません。',
		text2: '2. ご購入頂いたアイテムがご利用のアカウントに届くまで、回線状況により5分から40分の時間が必要です。期間限定キャンペーンが開催されている場合、キャンペーンに適用されない事態を防ぐため、キャンペーンが終了する1時間前に購入を完了させてください。',
		text3: '3. ご不明な点がございましたら、カスタマーサポートまでご連絡ください：cat-contact_jp@funtoygame.com（お問い合わせから返信までに、3〜5日程度お時間をいただく場合があります）。',
		text4: '',
		text5: '',
		text6: '',
	},
	final: {
		success: 'チャージが成功しました',
		failed: 'チャージが失敗しました',
		goBack: 'ホームへ戻る',
		tips: 'アイテムはゲーム内メールにてお送りしました',
	},
	rule: {
		title: '注意事項',
		text1: '1. 購入する際に、取引情報を細心にご確認ください。 ご購入頂いたアイテムは、他のアカウントに移動させることができません。',
		text2: '2. ご購入頂いたアイテムがご利用のアカウントに届くまで、回線状況により5分から40分の時間が必要です。期間限定キャンペーンが開催されている場合、キャンペーンに適用されない事態を防ぐため、キャンペーンが終了する1時間前に購入を完了させてください。',
		text3: '3. ご不明な点がございましたら、カスタマーサポートまでご連絡ください：cat-contact_jp@funtoygame.com （お問い合わせから返信までに、3〜5日程度お時間をいただく場合があります）。',
		text4: '',
		text5: '5.可充值的点数卡面额，请以官方在平台上公布的面额为主，若平台上无此面额，将无法充值成功，官方也无法进行退款哦！',
		text6: '6.目前GASH+实体礼物卡、GASH电子钱包、MyCard电子钱包等不适用于此平台充值，请您特别留意，若购买错误导致无法充值，官方将无法受理，要麻烦您向GASH或MyCard办理后续作业。',
	},
	uidText: {
		tx1: 'ゲームUIDを入力してください',
		tx2: 'ログイン',
		tx3: 'ゲーム内でアカウント連携を行うとクーポン券がもらえます！',
		tx4: 'まずはアカウントにログインしてください',
	},
};
